import { render, staticRenderFns } from "./name.vue?vue&type=template&id=7f629b7a&"
import script from "./name.vue?vue&type=script&lang=ts&"
export * from "./name.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports